<script lang="ts">
import Vue from 'vue'
import Component from 'vue-class-component'
import AdminForm from '@/components/admin/AdminForm.vue'
import AdminMapLayerForm from '@/components/admin/mapLayer/AdminMapLayerForm.vue'
import { AloDbMapLayer } from '@/models/alodb/AloDbMapLayer'
import { SecurityItemsKeys } from '@/enum/SecurityItems'


const getDefaultConfig = () => {
  return {
        missionMode:false
      }
}

@Component({
  name: 'AdminMapLayer',
  components: {AdminMapLayerForm},
  props:{
    config:{      
      default:getDefaultConfig
    }
  }
})
export default class AdminMapLayer extends AdminForm<AloDbMapLayer> {  
  showDeleteAction:boolean  = true

  created() {                            
    if(!this.$store.myGetters.userSecurity[SecurityItemsKeys.ADMIN_MAP_LAYER].enable) {
      this.canRender = false       
      this.$router.push('/')
    }     
  }

  get itemTypeName() {
    return "MapLayer"
  }

  get originalLibelle() {
    return this.original.LAY_LIBELLE
  }


}
</script>